var URL = typeof window !== 'undefined' && window.URL ? window.URL : require('url').URL;

const _ = {
  first(arr) {
    return arr[0];
  },
  last(arr) {
    return arr[arr.length - 1];
  },
  compact(arr) {
    return arr.filter(Boolean);
  },
  pick(obj, attributes) {
    let returnObj = {};
    for (let attribute of attributes) {
      returnObj[attribute] = obj[attribute];
    }
    return returnObj;
  },
};

function normalizeStoreInfo({ appStoreInfo, playStoreInfo, searchMode = false }) {
  var appStore = {};
  if (appStoreInfo) {
    appStore = {
      logo: appStoreInfo.artworkUrl512,
      name: appStoreInfo.trackName,
      description: appStoreInfo.description,
      rating: appStoreInfo.averageUserRating,
      ratingCount: appStoreInfo.userRatingCount,
      developer: appStoreInfo.artistName,
      developerSiteUrl: appStoreInfo.sellerUrl,
      url: appStoreInfo.trackViewUrl,
      id: appStoreInfo.trackId,
      screenshotUrls: appStoreInfo.screenshotUrls,
      genres: appStoreInfo.genres,
      price: appStoreInfo.price,
      currency: appStoreInfo.currency,
    };
    if (appStoreInfo.screenshotUrls && appStoreInfo.screenshotUrls.length > 0) {
      appStore.image = appStoreInfo.screenshotUrls[0];
      appStore.images = appStoreInfo.screenshotUrls;
    }
  }
  var playStore = {};
  if (playStoreInfo) {
    playStore = {
      logo: playStoreInfo.icon,
      name: playStoreInfo.title,
      description: playStoreInfo.description,
      rating: playStoreInfo.score,
      ratingCount: playStoreInfo.reviews,
      developer: playStoreInfo.developer,
      developerSiteUrl: playStoreInfo.developerWebsite,
      url: playStoreInfo.url,
      id: playStoreInfo.appId,
      genres: [playStoreInfo.genre],
      shortDescription: playStoreInfo.summary,
      price: playStoreInfo.price,
      currency: playStoreInfo.currency,
    };
    if (playStoreInfo.screenshots && playStoreInfo.screenshots.length > 0) {
      playStore.image = playStoreInfo.screenshots[0];
      playStore.images = playStoreInfo.screenshots;
    }
  }
  let mobileAppInfo = Object.assign({}, appStore, playStore);
  if (searchMode) {
    mobileAppInfo = _.pick(mobileAppInfo, ['logo', 'name', 'url', 'id', 'developer', 'developerSiteUrl']);
    // temporary -->
    mobileAppInfo.developerWebSiteUrl = mobileAppInfo.developerSiteUrl;
    if (playStoreInfo) {
      mobileAppInfo.playstoreInfo = {
        appId: mobileAppInfo.id,
        developer: mobileAppInfo.developer,
      };
    } else if (appStoreInfo) {
      mobileAppInfo.appstoreInfo = {
        trackId: mobileAppInfo.id,
        artistName: mobileAppInfo.developer,
      };
    }
  }
  return mobileAppInfo;
}

async function guessCountryFromLanguage(lang) {
  let countries = { en: 'us', ko: 'kr', ja: 'jp' };
  let country = countries[lang];
  // if(!country){
  //   let possibleCountries = (await getLanguageCountries(lang)).map(c=>c.code_2)
  //   country = _.maxBy(possibleCountries, c=>Country.population(c))
  // }
  return country;
}

// let allCoutnryCodes = _.compact(Country.all().map(c=>c.ISO["2"]))

async function findAppStoreInfo({ url, urlOptions, country, lang, window }) {
  if (!country && lang) country = await guessCountryFromLanguage(lang);
  if (!url.startsWith('http')) url = 'https://' + url;
  // ***** apple app store ********* //
  let Url = new URL(url);
  let appId = _.last(Url.pathname.split('/')).replace('id', '');
  if (!appId.match(/\d+/)) {
    appId = Url.searchParams.get('id');
    if (!appId || !appId.match(/\d+/)) throw new Error(`Cannot find mobile app id of url ${url}`);
  }
  let pathBeginning = _.first(_.compact(Url.pathname.split('/')));
  // if country specific app store
  if (pathBeginning != 'app' && pathBeginning.length == 2) country = pathBeginning;
  let apiUrl = new URL(`https://itunes.apple.com/lookup`);
  apiUrl.searchParams.set('id', appId);
  if (country) apiUrl.searchParams.set('country', country);
  apiUrl = apiUrl.toString();
  if (typeof window == 'undefined') {
    const request = require('request');
    urlOptions = Object.assign({}, urlOptions, { url: apiUrl });
    let [error, response, body] = await new Promise((res, rej) =>
      request(urlOptions, function (error) {
        if (error) return rej(error);
        res(arguments);
      }),
    );
    let mobileApps = JSON.parse(body.toString());
    var mobileApp = mobileApps.results[0];
  } else {
    mobileApp = await new Promise((resolve, reject) => {
      jsonpCall(window, apiUrl, function (response) {
        resolve(response.results[0]);
      });
    });
  }
  return mobileApp;
}

async function appStoreSearch(term, country, lang, window, baseUrlOptions) {
  let appIdRegExp = /^(?:id)?\d{5,}$/;
  if (!country && lang) country = await guessCountryFromLanguage(lang);
  if (term.includes('apple.com') || term.includes('http://') || term.includes('https://')) {
    // User input is an URL
    var results = [await findAppStoreInfo({ url: term, lang, country, window })];
  } else if (appIdRegExp.test(term)) {
    // User input is an id
    let appId = term;
    if (!term.startsWith('id')) appId = 'id' + term;
    let url = `https://apps.apple.com/app/${appId}`;
    results = [await findAppStoreInfo({ url, lang, country, window })];
  } else {
    // User input is a search term
    let url = new URL('https://itunes.apple.com/search?entity=software');
    url.searchParams.set('term', term);
    if (country) url.searchParams.set('country', country);
    url = url.toString();
    if (typeof window == 'undefined') {
      const request = require('request');
      let urlOptions = Object.assign({ url }, baseUrlOptions);
      let [error, response, body] = await new Promise((res, rej) =>
        request(urlOptions, function (error) {
          if (error) return rej(error);
          res(arguments);
        }),
      );
      var data = JSON.parse(body);
    } else {
      data = await new Promise((resolve, reject) => {
        jsonpCall(window, url, function (response) {
          resolve(response);
        });
      });
    }
    results = data.results.slice(0, 30);
  }
  results = results.map(result => normalizeStoreInfo({ appStoreInfo: result, searchMode: true }));
  return results;
}

function jsonpCall(window, apiUrl, cb) {
  let jsonpCallBack = 'jsonp_callback_' + Math.round(1e9 * Math.random());
  window[jsonpCallBack] = function (body) {
    cb(body);
  };
  apiUrl = new URL(apiUrl);
  apiUrl.searchParams.set('callback', jsonpCallBack);
  var script = window.document.createElement('script');
  script.src = apiUrl.toString();
  window.document.getElementsByTagName('head')[0].appendChild(script);
}

module.exports = {
  guessCountryFromLanguage,
  appStoreSearch,
  findAppStoreInfo,
  normalizeStoreInfo,
};
